import { useEffect } from 'react';

/**
 * MetaManager component to handle page-specific or additional metadata
 * Note: Core branding metadata (title, favicon, description) is now managed by BrandingProvider
 */
function MetaManager() {
  useEffect(() => {
    // This component is currently a placeholder for page-specific metadata updates if needed in the future
  }, []);

  return null;
}

export default MetaManager;
